module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-jack.fc3da15c.svg";